export const darkTheme = {
  root: {
    fontSize: "1.125rem",
  },
};

export default {
  darkTheme,
};
